/**
 * Logger centralisé — supprime console.log/info/debug en production.
 * console.warn et console.error restent actifs pour ne pas masquer
 * les alertes légitimes de React, MUI et des librairies tierces.
 *
 * Initialisé au démarrage via `import './utils/logger'` dans index.js.
 */

const isProduction = process.env.NODE_ENV === 'production';

if (isProduction) {
  console.log   = () => {};
  console.info  = () => {};
  console.debug = () => {};
  // console.warn  — conservé (alertes React / MUI utiles même en prod)
  // console.error — conservé (erreurs critiques à surveiller)
}

export const logger = {
  log:   (...args) => { if (!isProduction) console.log(...args);   },
  info:  (...args) => { if (!isProduction) console.info(...args);  },
  debug: (...args) => { if (!isProduction) console.debug(...args); },
  warn:  (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};
